import React from "react";
import { useHistory } from "react-router-dom";
import { getContentGroupsViewPath } from "../organizeUtil";

import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

const NotFound = () => {
  const history = useHistory();
  const handleClick = () => history.push(getContentGroupsViewPath());
  return (
    <Grid
      container
      direction="column"
      justify="center"
      alignItems="center"
      spacing={2}
      style={{ height: "100%" }}
    >
      <Grid item>
        <Typography variant="h2" style={{ fontSize: "4rem" }}>
          404
        </Typography>
      </Grid>
      <Grid item>
        <Typography>It looks like this item doesn't exist.</Typography>
      </Grid>
      <Grid item>
        <Button
          onClick={handleClick}
          color="primary"
          variant="contained"
          style={{ width: "auto" }}
          aria-label="Go to Organize home screen"
        >
          Start Organizing
        </Button>
      </Grid>
    </Grid>
  );
};

export default NotFound;
